import React from 'react';
import { withStyles } from '@material-ui/core/styles';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import ChangePasswordForm from './forms/ChangePasswordForm';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import logo from '../../img/logo/logo_light.svg';
import { resetPassword } from '../../redux/actions/authActions';

const styles = {
  root: {
    display: 'flex', 
    justifyContent: 'space-around', 
    alignItems: 'stretch', 
    flexFlow: 'column wrap'
  },
  item: {
    flexBasis: 'initial',
    flexGrow: 1,
    display: 'inline-flex'
  }
}

class PasswordRecovery extends React.PureComponent {

  submit = values => {
    let data = new FormData()
    let token = this.props.match.params.token;
    let uid = this.props.match.params.uid;

    data.set('token', token);
    data.set('uid', uid);
    data.set('new_password', values.new_password);
    data.set('confirm_password', values.confirm_password);
    
    this.props.dispatch(resetPassword(data));
    this.props.history.push('/auth/login');
  } 

  render() {
    const { classes } = this.props;

    return (
      <main>
        <Grid container className={classes.root} spacing={8} alignItems="center">

          <Grid item xs={12} className={classes.item} style={{flexGrow: 1, justifyContent: 'center'}}>
            <img src={logo} style={{maxHeight: 36}} />
          </Grid>

          <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
            <Typography variant='headline'>Cambia tu contraseña </Typography>
          </Grid>

          <Grid item xs={12} className={classes.item} style={{flexGrow: 4, alignItems: 'center'}}>
            <ChangePasswordForm onSubmit={this.submit} showCancelBtn {...this.props} />
          </Grid>

          <Grid item xs={12} className={classes.item} style={{flexGrow: 1, alignItems: 'flex-end', justifyContent: 'center'}}>
            <Typography variant='caption'>Condiciones de uso &amp; Politica de Privacidad</Typography>
          </Grid>

        </Grid>
      </main>
    )
  }
}

const mapStateToProps = (state) => {
  return {
      auth: state.auth
  };
};

export default withRouter(
  connect(mapStateToProps)(
    withStyles(styles)(PasswordRecovery)
  )
);


// WEBPACK FOOTER //
// ./src/modules/auth/PasswordRecovery.js